import { render, staticRenderFns } from "./DisciplinaryPrevious.vue?vue&type=template&id=207f5341"
import script from "./DisciplinaryPrevious.vue?vue&type=script&lang=js"
export * from "./DisciplinaryPrevious.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports